import { render, staticRenderFns } from "./CustomCategoriesPage.vue?vue&type=template&id=f40f2156&scoped=true&"
import script from "./CustomCategoriesPage.vue?vue&type=script&lang=js&"
export * from "./CustomCategoriesPage.vue?vue&type=script&lang=js&"
import style0 from "./CustomCategoriesPage.vue?vue&type=style&index=0&id=f40f2156&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40f2156",
  null
  
)

export default component.exports